export const isQA = () => {
  return window.location.search.includes('qa=true');
};

export const groupByThree = (array, empty) => {
  let metaArray = [];
  let innerArray = [];
  let first = true;
  array.forEach((value, index) => {
    if (index % 3 === 0) {
      if (first) {
        innerArray.push(value);
        first = false;
      } else {
        metaArray.push(innerArray);
        innerArray = [value];
      }
    } else {
      innerArray.push(value);
    }
  });

  let count = 3 - innerArray.length;
  for (var i = 1; i <= count; i++) {
    innerArray.push(empty(innerArray + i));
  }
  metaArray.push(innerArray);

  return metaArray;
};

export const isGuid = (value) => {
  const guidRegEx =
    /^[{(]?[0-9A-Za-z]{8}[-]?([0-9A-Za-z]{4}[-]?){3}[0-9A-Za-z]{12}[)}]?$/;
  return guidRegEx.test(value);
};
